import { useEffect } from 'react';
import { useAuthStore } from '../stores/authStore';
import { useNavigate, useLocation } from 'react-router-dom';

const DASHBOARD_PATH = '/dashboard';
const RESIDENT_PROFILE_PATH = '/wallet';
const NATIONAL_OFFICIAL_PATH = '/ayuda';

export function useRedirectIfAuthenticated() {
  const token = useAuthStore((state) => state.token);
  const role = useAuthStore((state) => state.user?.role);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (token) {
      const defaultPath =
        role === 'resident'
          ? RESIDENT_PROFILE_PATH
          : role === 'national_official'
            ? NATIONAL_OFFICIAL_PATH
            : DASHBOARD_PATH;
      // Redirect to previous page or dashboard
      const from = location.state?.from?.pathname || defaultPath;
      navigate(from, { replace: true });
    }
  }, [token, role, navigate, location]);
}
